import React from 'react';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import { Container, Section } from 'components/shared';
import styled from 'styled-components';
import ImageVideo from 'components/components/atoms/ImageVideo';
import breakpoints from 'utils/breakpoints';
import { AspectRatio } from 'react-aspect-ratio';
import useBreakpoint from 'utils/hooks/useBreakpoint';
import {
  videoTranscriptFileUrl,
  videoTranscriptFileExtension,
} from 'utils/videoTranscriptFileUrl';
import { Helmet } from '@dr.pogodin/react-helmet';

const StyledContainer = styled(Container)`
  @media ${breakpoints.lg} {
    max-width: 1060px;
  }
  @media ${breakpoints.xl} {
    max-width: 1280px;
  }
`;

const ImageVideoContainer = ({ fields, rendering }) => {
  const video = getFieldValue(fields, 'video') || {};
  const image = getFieldValue(fields, 'image') || {};
  const videoAutoPlay = getFieldValue(fields, 'videoAutoplay');
  const displayOption = video && video.type ? 'Video' : 'Image';
  const videoDescription = getFieldValue(fields, 'videoTranscriptTitle');
  const videoTranscript = getFieldValue(fields, 'videoTranscriptFile') || {};
  const videoAriaLabel = getFieldValue(fields, 'videoDescription');
  const autoPlay = getFieldValue(fields, 'autoPlay');

  const breakpoint = useBreakpoint(
    typeof window !== 'undefined' && window.innerWidth,
  );
  const isMobile = ['sm', 'xs'].includes(breakpoint);
  const ratio = isMobile && displayOption === 'Image' ? '330/220' : '1280/650';

  return (
    <>
      {isMobile && image.srcMobile && (
        <Helmet>
          <link
            fetchPriority='high'
            rel='preload'
            as='image'
            href={image.srcMobile}
          />
        </Helmet>
      )}
      {!isMobile && image.src && (
        <Helmet>
          <link
            fetchPriority='high'
            rel='preload'
            as='image'
            href={image.src}
          />
        </Helmet>
      )}
      {!isMobile && video.href && (
        <Helmet>
          <link
            fetchPriority='high'
            rel='preload'
            as='video'
            href={video.href}
          />
        </Helmet>
      )}
      <Section>
        <StyledContainer>
          <AspectRatio ratio={ratio}>
            <ImageVideo
              removeTabIndex // use this props remove tabindex
              src={
                displayOption === 'Image'
                  ? isMobile && image.srcMobile
                    ? image.srcMobile
                    : image.src
                  : video.href
              }
              alt={displayOption === 'Image' ? image.alt : videoAriaLabel}
              displayOption={displayOption}
              videoType={video && video.type ? video.type : ''}
              autoplay={autoPlay}
            />
          </AspectRatio>
          {displayOption === 'Video' &&
            videoDescription &&
            videoTranscript &&
            videoTranscript.link &&
            videoTranscript.link.href && (
              <span className='richtext text-left text-md leading-7 font-graphie text-mattamy-blue mt-2 md:pl-6 md:ml-10 lg:pl-8 lg:ml-6'>
                {'Transcript: '}
                <a
                  href={videoTranscriptFileUrl(videoTranscript)}
                  download={
                    videoTranscript.name +
                    videoTranscriptFileExtension(videoTranscript.extension)
                  }
                  className='underline'
                  aria-label={'Download ' + videoDescription + ' transcript'}
                >
                  {videoDescription}
                </a>
              </span>
            )}
        </StyledContainer>
      </Section>
    </>
  );
};

export default ImageVideoContainer;
